import { render, staticRenderFns } from "./PostGalleryPreviewDesktop.vue?vue&type=template&id=5f81ce2b"
import script from "./PostGalleryPreviewDesktop.vue?vue&type=script&lang=ts"
export * from "./PostGalleryPreviewDesktop.vue?vue&type=script&lang=ts"
import style0 from "./PostGalleryPreviewDesktop.vue?vue&type=style&index=0&id=5f81ce2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports